import type { ReactNode } from "react";

import { cn } from "./cn";

type EmptyStateProps = Readonly<{
  title: string;
  description?: ReactNode;
  /** A decorative icon (it is hidden from a screen reader). */
  icon?: ReactNode;
  /** The next step, usually a `Button`. */
  action?: ReactNode;
  className?: string;
}>;

/** What a list or a table shows when there is nothing to show. It says why and what to do next. */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-2 px-4 py-10 text-center [&_svg]:size-8 [&_svg]:text-muted-foreground",
        className,
      )}
    >
      {icon ? <span aria-hidden="true">{icon}</span> : null}
      <p className="m-0 text-base font-semibold text-foreground">{title}</p>
      {description ? (
        <p className="m-0 max-w-prose text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
